module.exports = __webpack_public_path__ + "static/media/Sentinel-Diagnostics.62a9d26d.png";